const ProfileActionConstants = {
    GET_PROFILE: 'PROFILE__GET_PROFILE',
    GET_PROFILE_SUCCESS: 'PROFILE__GET_PROFILE_SUCCESS',
    GET_PROFILE_FAIL: 'PROFILE__GET_PROFILE_FAIL',

    SAVE_PROFILE: 'PROFILE__SAVE_PROFILE',
    SAVE_PROFILE_SUCCESS: 'PROFILE__SAVE_PROFILE_SUCCESS',
    SAVE_PROFILE_FAIL: 'PROFILE__SAVE_PROFILE_FAIL',
};

export default ProfileActionConstants;
